import OhsRecordFieldType from 'global-services/constants/record-field/OhsRecordFieldType';

export const OhsWorkerNameRecordField = new OhsRecordFieldType('name', "Worker's Name");

export const OhsReferenceRecordField = new OhsRecordFieldType('referenceId', 'Employee Number');

export const OhsPositionRecordField = new OhsRecordFieldType('position', 'Position Title');
export const OhsNameRecordField = new OhsRecordFieldType('name', 'Name');
export const OhsOtherPositionRecordField = new OhsRecordFieldType(
  'positionOther',
  'Position Other'
);
export const OhsEmailRecordField = new OhsRecordFieldType('email', 'Email');

export const OhsManagerRecordField = new OhsRecordFieldType('managerName', "Manager's Name");
export const OhsManagerEmailRecordField = new OhsRecordFieldType('managerEmail', "Manager's Email");
export const OhsStartDateRecordField = new OhsRecordFieldType('dateStarted', 'Start Date');
export const OhsPersonalTelephoneRecordField = new OhsRecordFieldType(
  'personalPhone',
  'Personal Telephone'
);
export const OhsTelephoneRecordField = new OhsRecordFieldType('phone', 'Telephone');
export const OhsPersonalEmailRecordField = new OhsRecordFieldType(
  'personalEmail',
  'Personal Email'
);
export const OhsAddressRecordField = new OhsRecordFieldType('postalAddress', 'Address');

export const OhsDOBRecordField = new OhsRecordFieldType('dateOfBirth', 'Date of Birth');
export const OhsGenderRecordField = new OhsRecordFieldType('gender', 'Gender');

export const OhsGenderOtherRecordField = new OhsRecordFieldType('genderOther', 'Gender other');
export const OhsEmergencyContactNameRecordField = new OhsRecordFieldType(
  'emergencyContactName',
  'Emergency Contact Name'
);
export const OhsEmergencyContactPhoneRecordField = new OhsRecordFieldType(
  'emergencyContactPhone',
  'Emergency Contact Telephone'
);

export const OhsNotesRecordField = new OhsRecordFieldType('notes', 'Other Information');
export const OhsProfilePictureRecordField = new OhsRecordFieldType('avatar', 'Profile Picture');

export const OhsPositionCusvalsRecordField = new OhsRecordFieldType(
  'positionCusvals',
  'Position Custom Details'
);
export const OhsGenderCusvalsRecordField = new OhsRecordFieldType(
  'genderCusvals',
  'Gender Custom Details'
);
